import React from "react";
import withMotion from "../../../../Utils/withMotion";
import Sidebar from "../../Sidebar/Sidebar";
import "../../Blog.scss";
import { Link } from "react-router-dom";

//Utils
import { mapBlogs } from "../../Pagination/utils";

//Images
import img001 from "../../images/patioEdging/blog-edge-patio-001.jpeg";
import img002 from "../../images/patioEdging/blog-edge-patio-001.jpeg";
import img003 from "../../images/patioEdging/blog-edge-patio-001.jpeg";

// SEO
import SEO from "../../../../SEO/index.js";
import StructuredData from "../../../../SEO/structuredData";
import { ViewPavers } from "../../../../CTA/CTA";

export const PatioEdgingData = {
  title: "What is the Best Way to Edge a Paver Patio? Our Favorite Ideas",
  image: img001,
  destination: "/blog/best-way-edge-paver-patio-favorite-ideas",
  date: "September 13, 2016",
  categories: [
    "blog",
    "patios",
    "paving-stones",
    "retaining-walls",
    "walkways",
  ],
};

const PatioEdging = () => {
  const blog = [PatioEdgingData];

  return (
    <>
      <SEO
        title="Paver Edging Ideas - The Best Ways to Edge a Patio"
        description="Patio edge ideas aren't only critical to research for their aesthetics, but learning the best way to edge paver areas will also help your surfaces to be more durable."
        profileURL={
          "https://www.pacificpavingstone.com/blog/best-way-edge-paver-patio-favorite-ideas"
        }
      />
      <StructuredData
        orgaCreator={{
          "@context": "https://schema.org/",
          "@type": "BlogPosting",
          author: {
            "@type": "Organization",
            name: "Pacific Pavingstone",
          },
          URL: "https://www.pacificpavingstone.com/blog/best-way-edge-paver-patio-favorite-ideas",
          headline: "Paver Edging Ideas - The Best Ways to Edge a Patio",
          description:
            "Patio edge ideas aren't only critical to research for their aesthetics, but learning the best way to edge paver areas will also help your surfaces to be more durable.",
          image: {
            "@type": "ImageObject",
            url: "https://www.pacificpavingstone.com/static/media/blog-edge-patio-001.16cc7aa0.jpeg",
          },
          datePublished: "2016-09-13",
          publisher: {
            "@type": "Organization",
            name: "Pacific Pavingstone",
          },
        }}
      />
      <div className="container-fluid page-blog">
        <div className="row justify-content-center">
          <div className="col-11 col-lg-6">
            {mapBlogs(1, blog, true)}
            <p>
              Just as an intricate picture frame can enhance a work of art,
              framing your paver patio can create a stunning visual effect.
              However, patio edge ideas aren’t only critical to research for
              their aesthetic features, but learning the best way to edge paver
              patio areas, walkways, or driveways will also help your surfaces
              to be more durable.
            </p>
            <h4>Why is the Best Way to Edge a Patio So Important?</h4>
            <p>
              Paver patios, walkways, and driveways are installed in an
              interlocking fashion. Before pavers can be laid, ground is
              excavated, stone and/or sand are carefully added and graded, and
              the pavers set atop. Joint materials such as polymeric sand are
              swept into the paver joints to lock them together.
              <br />
              <br />
              However, when you would walk towards the edges of these surfaces,
              it would become very easy to displace the pavers on the edge
              without some means of preventing them to shift horizontally.
              <br />
              <br />A common yet unfortunate sight on a DIY paver project is
              where the novice installer didn’t realize the best way to edge a
              patio. We frequently see these edges leaning or sinking, and
              joints between paving stones separating. These transitional areas
              add complication to paver installation projects as pavers,
              irrigation, lawns, and/or planting beds intersect.
            </p>
            <h4>Patio Edging Best Practices for Southern California</h4>
            <p>
              Unlike many areas in the country that experience significant
              ground freezing and thawing in winter, Southern California soil
              doesn’t pose that particular challenge. If you lived in an area
              where soil froze regularly, you would need to have the stone and
              sand base under your patio extend 12” underground, past where
              pavers are seen.
              <br />
              <br />
              However, in Southern California the ground does not substantially
              freeze, so the foundation under patio, walkways, and driveway
              edges are treated differently in most circumstances. After the
              main surface of the patio is laid out and all the cuts are made, a
              trench approximately 8” wide and 8” deep is dug around the paver
              area. Concrete is then poured to provide a sturdy base that will
              not shift. The pavers used to border the patio are then either
              laid into wet concrete or attached with construction adhesive.
              <br />
              <br />
              This edge provides a fixed edge that won’t allow edges to shift
              easily when weight is applied to them. The patio, walkway, or
              driveway surface appears the same in all of these areas, but with
              a different base.
            </p>
            <h4>Best Way to Edge a Patio Near a Retaining Wall</h4>
            <img src={img002} alt="Feature" />
            <p>
              Small retaining walls are often a part of landscape designs to
              provide decorative accents, separate areas, and to address slight
              grade transitions. The best way to edge paver patio areas in those
              areas, is to continue the base under the wall.
              <br />
              <br />
              The vertical wall actually begins below the grade. The heavy
              weight of wall block can, in most circumstances, provide the
              horizontal restraint to keep paver patio edges from moving.
            </p>
            <h4>Paver Edge Ideas for Distinctive Landscape Design</h4>
            <p>
              While making the right decisions for the best way to edge a paver
              patio or other surface, a great design opportunity arises. These
              transitions are a great way to incorporate unique and decorative
              paver edge ideas into your design.
              <br />
              <br />
              These choices can take the same materials and create a one of a
              kind look for your property. You and your landscape designer may
              work together to define your preferences for your project to keep
              things subtle or make a bold statement.
            </p>
            <h4>Subtle Paver Edge Ideas</h4>
            <p>
              Patio edge ideas or the areas at transitions of other paver
              surfaces can be treated the same as the rest of your surface. One,
              continuous pattern of pavers can be laid right to the edge.
              <br />
              <br />
              If your project will look better with a texture change, while
              continuing the same colors, pavers in a similar color blend can be
              chosen, only with a different size, or arranged in a different
              fashion.
              <br />
              <br />
              Subtle paver edge ideas often use border effects such as a random,
              sailor, or soldier course of similar stones used to frame in the
              area.
            </p>
            <h4>Paver Edge Ideas that Accent Surfaces</h4>
            <div className="row">
              <div className="col-12 col-md-5">
                <img src={img003} alt="Feature" />
              </div>
              <div className="col-12 col-md-7">
                <p>
                  In many cases, a couple colors of paving stones are used on
                  projects we complete here in Southern California. Ideas for
                  patio edges may be inspired by pulling in colors of your
                  structure or a unique color you choose for an accent.
                  <br />
                  <br />
                  Your patio, driveway, or walkway surface may have used 2-3
                  colors of pavers randomly throughout the design. Unique ideas
                  for patio edges or walkway borders can emerge when picking one
                  of those colors to frame and highlight one specific color.
                </p>
              </div>
            </div>
            <p>
              Even when choosing subtle paver edge ideas, these accent lines can
              be incorporated further into the patio, with a band of contrasting
              color being displayed 6” to 12” in from the patio edge.
              <br />
              <br />
              Materials can even be mixed together for even more design
              flexibility. Pavers can be mixed with natural stone such as
              travertine. The possibilities are almost endless!
            </p>
            <h4>
              Getting Unique Paver Edge Ideas AND Using the Best Ways to Edge a
              Paver Patio
            </h4>
            <p>
              Your project is a substantial investment to enhance your property.
              You shouldn’t have to choose between getting a gorgeous design or
              a proper installation. It’s possible to make sure your paving
              contractor knows the best way to edge a paver patio all while
              finding unique paver edge ideas.
              <br />
              <br />
              Your project is a substantial investment to enhance your property.
              You shouldn’t have to choose between getting a gorgeous design or
              a proper installation. It’s possible to make sure your paving
              contractor knows the best way to edge a paver patio all while
              finding unique paver edge ideas.
            </p>
            <p>
              Take some time and browse <Link to="/gallery">galleries</Link> of
              our work. Pay close attention to the various paver edge ideas we
              used in projects and take note of which ones are your favorites.{" "}
              <Link to="/contact-us">
                When you’re ready to get a free consultation, contact us via our
                website, or call us at (818) 275-8613.
              </Link>
            </p>
            <ViewPavers/>
          </div>
          <Sidebar />
        </div>
      </div>
    </>
  );
};

export default withMotion(PatioEdging);
